import type { CashLocationType } from './cash-locations.dto.js';
import type { CashSessionCloseMode, CashSessionStatus } from './cash-sessions.dto.js';
import type {
  CashVarianceActionStatus,
  CashVarianceActionType,
  CashVarianceCaseStatus,
  CashVarianceStage,
} from './cash-variance.dto.js';

export const cashReportLocationScopeValues = ['station', 'location', 'company'] as const;
export type CashReportLocationScope = (typeof cashReportLocationScopeValues)[number];

export const cashReportMovementCategoryValues = [
  'operational',
  'varianceRecognition',
  'varianceRecovery',
  'overageRemoval',
  'purchasePayout',
  'transfer',
  'expense',
  'funding',
  'adjustment',
] as const;
export type CashReportMovementCategory = (typeof cashReportMovementCategoryValues)[number];

export const cashReportPhysicalEffectValues = ['increase', 'decrease'] as const;
export type CashReportPhysicalEffect = (typeof cashReportPhysicalEffectValues)[number];

export const cashReportSourceTypeValues = [
  'cashMovement',
  'cashSession',
  'cashLocation',
  'purchase',
  'varianceCase',
  'varianceAction',
  'expense',
  'transfer',
  'funding',
  'adjustment',
] as const;
export type CashReportSourceType = (typeof cashReportSourceTypeValues)[number];

export interface CashReportActorRefDto {
  userId: string;
  displayName: string | null;
  email: string | null;
  employeeId: string | null;
  employeeNumber: string | null;
}

export interface CashReportCashLocationRefDto {
  cashLocationId: string;
  kind: CashLocationType;
  scope: CashReportLocationScope;
  name: string | null;
  storeId: string | null;
  storeName: string | null;
  locationId: string | null;
  locationName: string | null;
  stationId: string | null;
  stationName: string | null;
}

export interface CashReportSessionRefDto {
  cashSessionId: string;
  status: CashSessionStatus;
  openedAt: string;
  closedAt: string | null;
  closeMode: CashSessionCloseMode | null;
  displayName: string | null;
}

export interface CashReportSourceRefDto {
  sourceType: CashReportSourceType;
  sourceId: string;
  displayName: string | null;
  occurredAt: string | null;
}

export interface CashReportVarianceCaseRefDto {
  caseId: string;
  stage: CashVarianceStage | null;
  status: CashVarianceCaseStatus | null;
}

export interface CashReportVarianceActionRefDto {
  actionId: string;
  actionType: CashVarianceActionType;
  status: CashVarianceActionStatus | null;
}

export interface CashReportPurchasePayoutRefDto {
  purchaseId: string;
  folioNumber: number | null;
  committedAt: string | null;
  cashSessionId: string | null;
  cashLocationId: string | null;
  paidAmountMinor: number;
}

export interface CashReportCategoryBreakdownDto {
  reportCategory: CashReportMovementCategory;
  totalInMinor: number;
  totalOutMinor: number;
  netAmountMinor: number;
  movementCount: number;
}
